import React from "react";
import { cn } from "../../components/ui";
import { getNotificationMeta, notificationToneClasses } from "./notificationMeta";

const sizes = {
  sm: "size-8 rounded-lg [&_svg]:size-4",
  md: "size-10 rounded-xl [&_svg]:size-[18px]",
  lg: "size-12 rounded-xl [&_svg]:size-5",
};

/** Tinted icon tile for a notification type */
export const NotificationIcon: React.FC<{ type: string; size?: keyof typeof sizes; className?: string }> = ({
  type,
  size = "md",
  className,
}) => {
  const { Icon, tone } = getNotificationMeta(type);
  return (
    <span
      aria-hidden
      data-tone={tone}
      className={cn(
        "flex shrink-0 items-center justify-center ring-1 ring-inset",
        sizes[size],
        notificationToneClasses[tone],
        className
      )}
    >
      <Icon />
    </span>
  );
};

export default NotificationIcon;
